import { composeReducers } from 'common/util/composeReducers';

import {
    ACTIONS,
} from 'forms/actions/events';

export function submitEventSignTask(state, action) {
    if (!action || action.type !== ACTIONS.SUBMIT_EVENT_SIGN_TASK) {
        return state;
    }

    const { success } = action.payload;
    const form = state.form;

    return {
        ...state,
        form: {
            ...form,
            submissionSuccess: success
        }
    };
}

export function getEventSignatureRequest(state, action){
    if (!action || action.type !== ACTIONS.GET_EVENT_SIGNATURE_REQUEST) {
        return state;
    }

    const signatureRequest = action.payload;
    return {
        ...state,
        form: {
            signatureRequest,
        },
    };
}

export function unloadEventSignatureRequest(state, action) {
    if (!action || action.type !== ACTIONS.UNLOAD_EVENT_SIGNATURE_REQUEST) {
        return state;
    }

    return {
        ...state,
        form: {},
    };
}

export default composeReducers(
    submitEventSignTask,
    getEventSignatureRequest,
    unloadEventSignatureRequest,
);
